import { CLIENT_LINK_RELEASE, desktopAppLabel, desktopRuntime, type DesktopRuntime } from "../lib/client-version";

/** Shows running versions, never substitutes the offered release for the installed app. */
export function ClientVersionDetails({ desktop = desktopRuntime(), interfaceVersion = CLIENT_LINK_RELEASE }: {
  desktop?: DesktopRuntime; interfaceVersion?: string;
}) {
  return <div className="rounded-2xl border border-cloud-200 bg-white/70 p-4 text-sm text-cloud-700">
    <dl className="space-y-2">
      <div className="flex justify-between gap-4"><dt>Chat interface</dt><dd className="font-semibold">{interfaceVersion}</dd></div>
      {desktop && <div className="flex justify-between gap-4"><dt>{desktopAppLabel(desktop.platform)} · installed</dt><dd className="font-semibold">{desktop.version || "Version unavailable"}</dd></div>}
    </dl>
    <p className="mt-3 text-xs leading-relaxed text-cloud-500">{desktop
      ? "The chat interface refreshes automatically. The installed app updates separately; it only installs an update after you approve the restart. Release notes don’t mean the installed app has updated."
      : "The chat interface refreshes automatically when it’s safe. There’s no desktop app to install in your browser."}</p>
  </div>;
}
